import type { TKey } from './types';

const ja: Record<TKey, string> = {
  'nav.library':            'ライブラリ',
  'nav.myBooks':            '私の本',
  'nav.credentials':        '認証',
  'nav.mindmap':            'マインドマップ',
  'nav.reading':            '読書',
  'nav.upload':             'Upload',
  'nav.signin':             'Sign in',
  'nav.signout':            'Sign out',
  'nav.localeSelect':       'Language',

  'brand.sub':              'ブッククエスト',
  'onboard.welcome':        'Start with one book.',
  'onboard.welcomeSub':     'Pick a curated title or upload your own PDF — receive a four-layer mindmap, nine-tier adaptive quiz, and lifelong credentials.',
  'onboard.featureMapTitle':  'Four-layer mindmap',
  'onboard.featureMapBody':   'From surface narrative (L1) to the unsaid premises (L4) — a knowledge map drawn across four layers by AI.',
  'onboard.featureQuizTitle': 'Nine-tier adaptive quiz',
  'onboard.featureQuizBody':  'IRT-based difficulty (T1–T9) adjusts to your understanding in real time.',
  'onboard.featureCredTitle': 'Lifelong credentials',
  'onboard.featureCredBody':  'Every completion is issued as a W3C Verifiable Credential — externally verifiable, kept for life.',
  'onboard.ctaBrowse':      'Browse curated books',
  'onboard.ctaUpload':      'Upload my PDF',
  'onboard.signedOutHint':  'Sign in first to save your progress.',
  'onboard.ctaSignIn':      'Sign in / Sign up',
  'common.loading':         '読み込み中…',
  'common.offline':         'オフライン',
  'common.free':            '無料',
  'common.error':           'エラー',
  'common.back':            '← ライブラリ',
  'common.continue':        '続ける',
  'common.submit':          '送信',
  'common.skip':            'スキップ',
  'common.next':            '次へ',
  'common.finish':          '完了',
  'common.startAssessment': '評価のみ開始',
  'theme.label':            'テーマ',
  'theme.light':            'ライト',
  'theme.dark':             'ダーク',
  'theme.system':           'システム',
  'sound.label':            '効果音',
  'sound.on':               'オン',
  'sound.off':              'オフ',
  'api.error.badRequest':   'リクエストが無効です。',
  'api.error.unauthorized': 'ログインが必要です。',
  'api.error.forbidden':    'このリソースへのアクセス権がありません。',
  'api.error.notFound':     '見つかりません — 移動または削除された可能性があります。',
  'api.error.tooLarge':     'ファイルが大きすぎます。100 MB 以内で再試行してください。',
  'api.error.unsupported':  '対応していないファイル形式です。',
  'api.error.rateLimited':  'リクエストが多すぎます — しばらく後で再試行してください。',
  'api.error.server':       'サーバーエラー — しばらく後で再試行してください。',
  'api.error.network':      'ネットワーク接続が切れました。',
  'api.error.unknown':      '不明なエラー',
  'a11y.skipToMain':        'メインコンテンツへスキップ',
  'notFound.kicker':        'Not Found · 404',
  'notFound.titleLine1':    'この経路は',
  'notFound.titleLine2':    '本棚にありません。',
  'notFound.lead':          '本が移されたか、最初から存在しないページです。図書館に戻ってやり直してください。',
  'notFound.pathLabel':     'リクエストパス',
  'notFound.cta':           '図書館へ',
  'footer.tagline':         '一冊がマインドマップと認証になる図書館',
  'footer.navLabel':        'フッターナビ',
  'footer.about':           '紹介',
  'footer.privacy':         'プライバシー',
  'footer.terms':           '利用規約',
  'footer.contact':         '連絡先',
  'reader.controls':              'リーダー操作',
  'reader.size':                  '文字',
  'reader.theme':                 'テーマ',
  'reader.previewFallback':       '本文プレビューが準備されていません。書籍解析後に表示されます。',
  'reader.stubNotice':            'リーダー環境のプレビュー。本文表示は次回リリースで有効化されます。',
  'reader.demoBody1':             '読書中に現れる重要概念、反論、定義、行動項目は色で示されます。',
  'reader.demoBody2':             '用語はその場で定義され、',
  'reader.demoBody3':             '読者が試すべきことは',
  'reader.demoHighlightYellow':   '重要概念',
  'reader.demoHighlightCoral':    '対立命題',
  'reader.demoHighlightBlue':     '定義',
  'reader.demoHighlightMint':     '行動項目',
  'reader.aside.legendLabel':     'ハイライト凡例',
  'reader.aside.legendYellow':    '重要概念',
  'reader.aside.legendCoral':     '反論・対立',
  'reader.aside.legendBlue':      '定義',
  'reader.aside.legendMint':      '行動項目',
  'reader.aside.metaLabel':       '書籍',
  'common.correct':         '正解です。',
  'common.notQuite':        '惜しい。',
  'common.save':            'あとで読む',
  'common.beginReading':    '読書を始める',
  'common.openMindmap':     'マインドマップを開く',
  'common.searchPlaceholder': 'タイトル・著者・ISBN で検索…',

  'library.kicker':         'Opening Collection · 100 vols',
  'library.heroLine1':      '100 冊から始まり、',
  'library.heroLine2':      '本棚は果てしなく続く。',
  'library.heroSub':        'オープニング・コレクション 100 選 — 一冊が 4-Layer マインドマップと 9-Tier 評価に生まれ変わる図書館。',
  'library.featured':       '今月のおすすめ',
  'library.curatedCount':   '厳選',
  'library.noBooks':        'まだ厳選された本がありません。シードスクリプトまたは管理画面をご利用ください。',
  'library.filterAll':      'すべて',
  'library.filterClassics': '古典',
  'library.filterPhilosophy': '哲学',
  'library.filterK5':       'K-5',
  'library.filter68':       '6-8',
  'library.filter912':      '9-12',

  'detail.previewNodes':    '4-Layer マインドマップ プレビュー',
  'detail.sampledQuestions': '三問プレビュー',
  'detail.bookMissing':     '書籍情報を取得できません。',
  'detail.noQuestions':     '問題はまだ準備中です — パイプライン処理中の可能性があります。',
  'detail.byAuthor':        '著者',
  'detail.sourceLabel':            '出典',
  'detail.firstQuoteLabel':        '冒頭引用',
  'detail.relatedCredentialLabel': '関連認証',
  'detail.relatedCredentialBody':  'この本で Major 認証を獲得できます。',
  'detail.pages':           'ページ',
  'detail.metaSeparator':   ' · ',

  'map.fourLayers':         '4-Layer',
  'map.navigation':         'ナビゲーション',
  'map.surface':            'L1 表層',
  'map.argument':           'L2 論証',
  'map.concept':            'L3 概念',
  'map.meta':               'L4 メタ — 語られない前提',
  'map.notReady':           'マインドマップはまだ準備中です。',
  'map.loadingMap':         'マインドマップを読み込み中…',
  'map.selectNode':         'ノードを選択してください',
  'map.selectNodeSub':      '各ノードは引用 (L1)、論証 (L2)、概念 (L3)、または沈黙の前提 (L4) を持ちます。',
  'map.hoverHint':          'ノードにマウスを合わせる',

  'quiz.of':                ' / ',
  'quiz.minRemaining':      '分残り',
  'quiz.noQuestions':       '利用可能な問題がありません。',
  'quiz.tier':              '難易度',
  'quiz.celebration.kicker':         '完読',
  'quiz.celebration.titleLine1':     '一冊の本を',
  'quiz.celebration.titleLine2':     '読み終えました。',
  'quiz.celebration.lead':           '評価は認証として封印され、生涯保管されます。',
  'quiz.celebration.correct':        '正解',
  'quiz.celebration.theta':          'θ 最終',
  'quiz.celebration.viewCredential': '認証を見る',

  'creds.kicker':           '認証',
  'creds.heroLine':         'あなたが得た',
  'creds.heroEm':           '読書の',
  'creds.heroSub':          'すべてのマイルストーンを W3C Verifiable Credentials として発行 — 外部検証可、生涯保管。',
  'creds.master':           'Master ★',
  'creds.recent':           '最近の発行',
  'creds.pastDays':         '直近 30 日',
  'creds.noneYet':          '本を読了すると最初の認証が手に入ります。',
  'creds.urn':              'URN',
  'creds.issued':           '発行',
  'creds.anchor':           'アンカー',
  'creds.tier.micro':       'マイクロ',
  'creds.tier.standard':    'スタンダード',
  'creds.tier.major':       'メジャー',
  'creds.tier.master':      'マスター',
  'creds.tier.legendary':   'レジェンダリー',
  'creds.count':            '枚',
  'creds.aside.tiersLabel':    '5-Tier 階梯',
  'creds.aside.tiersBody':     'Micro → Standard → Major → Master → Legendary。生涯で 80〜100 枚を獲得。',
  'creds.aside.verifyLabel':   '外部検証',
  'creds.aside.verifyBody':    'URN は W3C Verifiable Credentials 標準に準拠 — 任意の検証機関で確認可能。',
  'creds.aside.standardLabel': '標準',
  'creds.justIssued':          '発行直後',
  'creds.copied':              'コピー済み',
  'creds.copyFailed':          'コピー失敗',
  'creds.share':               '共有',
  'creds.verifyExternally':    '外部検証',
  'creds.verifierComing':      '検証ポータルは近日公開。',
  'creds.shareNative':         '共有',
  'creds.print':               '印刷·PDF',
  'source.curated':         '厳選',
  'source.user_upload':     'ユーザー投稿',
  'source.partner':         'パートナー',
  'source.public_domain':   'パブリックドメイン',
  'source.institution':     '機関',
  'auth.signinTitle':       'Sign in',
  'auth.signupTitle':       'Sign up',
  'auth.magicTitle':        'Magic link',
  'auth.email':             'Email',
  'auth.password':          'Password',
  'auth.signin':            'Sign in',
  'auth.signup':            'Create account',
  'auth.sendMagic':         'Send magic link',
  'auth.switchToSignup':    'New here? Create account',
  'auth.switchToSignin':    'Already have an account? Sign in',
  'auth.switchToMagic':     'Use magic link instead',
  'auth.notConfiguredBanner': 'Supabase is not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in packages/web-app/.env.local.',
  'auth.checkEmail':        'Check your email to confirm your account.',
  'auth.magicSent':         'Magic link sent — check your email.',
  'auth.working':           'Working…',
  'auth.aside.whyLabel':       'BookQuest を選ぶ理由',
  'auth.aside.why1':           '一冊が 4-Layer マインドマップに。',
  'auth.aside.why2':           '9-Tier 評価で読解力を測定。',
  'auth.aside.why3':           '生涯にわたる認証が積み重なる。',
  'auth.aside.privacyLabel':   'プライバシー',
  'auth.aside.privacyBody':    '読書データは本人のみが閲覧します。',

  'upload.title':           'Upload a book',
  'upload.help':            'PDFs only. The system de-duplicates globally — if anyone has already processed this file you get instant free access.',
  'upload.fileLabel':       'PDF file',
  'upload.countryLabel':    'Country (for pricing)',
  'upload.submit':          'Upload',
  'upload.submitting':      'Uploading…',
  'upload.chooseFirst':     'Choose a PDF first.',
  'upload.failed':          'Upload failed',
  'upload.resultTitle':     'Result',
  'upload.dedupeStatus':    'De-dup status',
  'upload.paymentStatus':   'Payment status',
  'upload.amount':          'Amount',
  'upload.jobId':           'Job ID',
  'upload.eta':             'ETA',
  'upload.watchProgress':   'Watch progress',
  'job.title':              '分析の進行',
  'job.processing':         '本を分析し問題を生成中…',
  'job.stage':              '段階',
  'job.cost':               '累計コスト',
  'job.done':               '完了しました',
  'job.failed':             '処理中にエラーが発生しました',
  'job.openBook':           '本へ移動',
  'job.eta':                '通常20分ほど。閉じてもバックグラウンドで続行します。',
  'upload.aside.formatLabel':  '対応フォーマット',
  'upload.aside.formatBody':   'テキスト抽出可能な PDF。50 MB 以内。',
  'upload.aside.etaLabel':     '処理時間の目安',
  'upload.aside.etaBody':      '5〜15 分。本の長さとキュー状況によります。',
  'upload.aside.privacyLabel': 'プライバシー',
  'upload.aside.privacyBody':  'アップロード PDF は解析後に廃棄されます。',
  'nav.achievements':       '達成',
  'nav.admin':              '管理',
  'gam.kicker':             'あなたの歩み',
  'gam.heroLine':           '読んで、解いて、',
  'gam.heroEm':             '成長する',
  'gam.heroSub':            '問題を解き、本を読み終えるたびにXPとバッジを獲得。レベルを上げてリーダーボードに名を刻みましょう。',
  'gam.levelLabel':         'レベル',
  'gam.xpTotal':            '累計XP',
  'gam.xpUnit':             'XP',
  'gam.toNext':             '次のレベルまで',
  'gam.maxLevel':           '最高レベル',
  'gam.badges':             'バッジ',
  'gam.badgesSub':          '学びの軌跡',
  'gam.locked':             '未獲得',
  'gam.noBadges':           'まだバッジがありません — 最初の問題から始めましょう。',
  'gam.leaderboard':        'リーダーボード',
  'gam.leaderboardSub':     'XPランキング',
  'gam.rank':               '順位',
  'gam.you':                'あなた',
  'gam.emptyBoard':         'まだ順位がありません。',
  'gam.period.daily':       '今日',
  'gam.period.weekly':      '今週',
  'gam.period.monthly':     '今月',
  'gam.period.all':         '全期間',
  'gam.howXp':              'XPの獲得方法',
  'gam.howXpSub':           'このようにXPが貯まります',
  'gam.levelCurve':         'レベル曲線',
  'gam.levelN':             'Lv',
  'gam.aside.label':        'XPとは？',
  'gam.aside.body':         'XPは学習活動の累積記録です。正解・ステージ完了・読了がすべて加算されレベルになります。',
  'gam.aside.fairLabel':    '公正な加算',
  'gam.aside.fairBody':     '同じ問題を繰り返し解いても、XPは最初の正解時に一度だけ加算されます。',
  'gam.xpRule.answer_correct':     '問題の正解',
  'gam.xpRule.stage_complete':     'ステージ完了',
  'gam.xpRule.book_clear':         '本の読了',
  'gam.xpRule.cr_submit':          '記述式の提出',
  'gam.xpRule.streak_day':         '連続学習(1日)',
  'gam.xpRule.question_propose':   '問題の提案',
  'gam.xpRule.question_adopted':   '提案の採用',
  'gam.xpRule.review_participate': 'レビュー参加',
  'detail.propose':            '問題を提案',
  'prop.title':                '問題を提案する',
  'prop.help':                 'この本に合う選択式問題を作って提案しましょう。運営者が採用すると問題バンクに追加され、XPとバッジを獲得します。',
  'prop.stemLabel':            '問題（設問）',
  'prop.stemPlaceholder':      '例）この章で主人公が去った理由として最も適切なものは？',
  'prop.choicesLabel':         '選択肢（正解を選んでください）',
  'prop.choiceCorrect':        '正解',
  'prop.choicePlaceholder':    '選択肢の内容',
  'prop.explanationLabel':     '解説（任意）',
  'prop.explanationPlaceholder': '本文を根拠に正解の理由を説明してください。',
  'prop.submit':               '提案を送信',
  'prop.submitting':           '送信中…',
  'prop.success':              '提案を受け付けました。採用されたらお知らせします。',
  'prop.needStem':             '問題文を入力してください。',
  'prop.needChoices':          '選択肢を2つ以上入力してください。',
  'prop.needCorrect':          '正解の選択肢を選んでください。',
  'prop.myProposals':          '私の提案',
  'prop.none':                 'まだ提案した問題がありません。',
  'prop.status.pending':       '審査待ち',
  'prop.status.accepted':      '採用',
  'prop.status.rejected':      '不採用',
  'prop.aside.howLabel':       '仕組み',
  'prop.aside.howBody':        '提案 → 運営者審査 → 採用で問題バンクへ（追加検査の後に出題）。良い問題ほど採用されやすいです。',
  'prop.aside.rewardLabel':    '報酬',
  'prop.aside.rewardBody':     '提案でXP、採用でさらにXPと「問題提案者」バッジを獲得します。',
  'prop.difficulty':           '難易度の提案 (任意)',
  'prop.difficultyNone':       '未指定',
  'detail.report':            '達成レポート',
  'quiz.celebration.viewReport': 'レポートを見る',
  'report.kicker':            '評価レポート',
  'report.title':             '達成レポート',
  'report.accuracy':          '全体正答率',
  'report.level':             '習熟度',
  'report.theta':             '能力推定(θ)',
  'report.thetaNote':         '相対推定値 — 補正前の近似',
  'report.attempted':         '解答数',
  'report.unit':              '問',
  'report.naep':              'NAEP 認知領域',
  'report.lidia':             'LIDIA 評価領域',
  'report.trend':             '成長推移',
  'report.window':            '区間',
  'report.notAttempted':      '未受験',
  'report.empty':             'まだ評価記録がありません',
  'report.emptySub':          '問題を解くと領域別の達成度がここに表示されます。',
  'report.startQuiz':         '評価を開始',
  'report.honestyLabel':      '指標について',
  'report.honestyBody':       'レベル·θは補正前の相対近似値です。標準スコア(Lexile·入試等級)ではありません。',
  'report.viewCredential':    '認証書を見る',
  'report.viewAchievements':  '達成·XP',
  'report.retry':             'もう一度',
  'report.naep.locate_recall':       '探索·記憶',
  'report.naep.integrate_interpret': '統合·解釈',
  'report.naep.critique_evaluate':   '批判·評価',
  'footer.larc':              '審査委員会',
  'larc.kicker':             '信頼と透明性',
  'larc.title':              'LARC 審査委員会',
  'larc.lead':               'すべての問題はAI生成後、多段階の審査を経ます。LARCはその過程を公開します。',
  'larc.missionLabel':       '使命',
  'larc.missionBody':        '評価の公正性と正確性を守ります。AIが作った問題を人と交差モデルが検証し、信頼できる読解力測定を提供します。',
  'larc.criteriaLabel':      '審査基準',
  'larc.crit1':              '根拠整合 — 正解が本文に実際に基づくか',
  'larc.crit2':              '明確性 — 設問·選択肢が曖昧でないか',
  'larc.crit3':              '弁別力 — 誤答が妥当で正解が一意か',
  'larc.crit4':              '学年·偏り — 対象学年に適し偏りがないか',
  'larc.statsLabel':         '審査活動',
  'larc.stApproved':         '承認',
  'larc.stPending':          '審査待ち',
  'larc.stReviewed':         'AI審査',
  'larc.stRejected':         '却下',
  'larc.stTotal':            '全問題',
  'larc.stReports':          '通報処理',
  'larc.note':               '集計数値のみ公開され、個人情報·問題内容は含まれません。',
  'prelearn.title':          '事前学習',
  'prelearn.subtitle':       '読む前の背景知識',
  'prelearn.books':          '購入·書店',
  'prelearn.media':          '動画·背景',
  'prelearn.note':           '外部サイトの検索に移動します。',
  'creds.summaryLabel':      '総合読解認証',
  'creds.summaryTotal':      '総認証',
  'creds.summaryBooks':      'カバーした本',
  'creds.summaryHighest':    '最高等級',
  'nav.vault':               '知識庫',
  'vault.title':             '知識の蔵',
  'vault.subtitle':          'メモ·印象的な一文·洞察を集める',
  'vault.kindMemo':          'メモ',
  'vault.kindQuote':         '引用',
  'vault.kindInsight':       '洞察',
  'vault.kindFeedback':      'フィードバック',
  'vault.contentPlaceholder': '覚えておきたい内容を書きましょう',
  'vault.tagsPlaceholder':   'タグ (カンマ区切り)',
  'vault.add':               '保存',
  'vault.searchPlaceholder': '内容を検索',
  'vault.allKinds':          'すべて',
  'vault.empty':             'まだ保存したノートがありません。',
  'vault.delete':            '削除',
  'vault.added':             '保存しました。',
  'vault.deleted':           '削除しました。',
  'vault.needContent':       '内容を入力してください。',
  'vault.export':            'エクスポート',
  'vault.exportMd':          'Markdown',
  'vault.exportJson':        'JSON',
  'verify.title':            '認証書の検証',
  'verify.checking':         '検証中…',
  'verify.valid':            '有効な認証書です',
  'verify.invalid':          '無効または取り消された認証書です',
  'verify.notFound':         '認証書が見つかりません',
  'verify.tier':             '等級',
  'verify.issued':           '発行日',
  'verify.note':             'BookQuestの発行記録と照合して検証します。個人情報は公開されません。',
};

export default ja;
